<template>
  <button
    v-loading="isLoading"
    class="i-button"
    :disabled="isDisabled || isLoading"
    :type="nativeType"
    :class="[
      `i-button--${type}`,
      size ? `i-button--${size}` : '',
      {
        'is-loading': isLoading,
        'is-icon': isIcon,
        'is-hovering': isHovering,
        'is-active': isActive,
      }
    ]"
  >
    <template v-if="$slots.default">
      <slot />
    </template>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    nativeType: {
      type: String,
      default: 'button',
    },
    size: {
      type: String,
      values: ['', 'small', 'medium', 'large'],
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isHovering: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
